// store.ts

import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';

import actionsReducer from '../slices/actionsSlice'; // Import the actions slice
import languageReducer from '../slices/languageSlice';
import notificationReducer from '../slices/notificationSlice';
import rtuReducer from '../slices/rtuSlice';
import thunk from 'redux-thunk';
import userReducer from '../slices/userSlice';

const store = configureStore({
  reducer: {
    notifications: notificationReducer,
    rtu: rtuReducer,
    language: languageReducer,
    user: userReducer,
    actions: actionsReducer,  // Add the actions slice to your store
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: process.env.NODE_ENV !== 'production',
});

if (typeof window !== 'undefined' && (window as any).Cypress) {
  (window as any).__DMS_STORE__ = store;
}

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
